import { useState } from 'react';
import { Box, IconButton, LinearProgress, Modal, Paper, Typography } from '@mui/material'
import Grid from "@mui/material/Grid2";
import { Location } from "src/stateManagement/redux/slices/location/interfaces";
import HighlightOffTwoToneIcon from "@mui/icons-material/HighlightOffTwoTone";
import { AssignedModule } from './assignActivities';
import { ReportManager } from './reportManager';
import './styles.scss'

export interface ActivitiesByAnalyser {
    userId: string;
    fullName: string;
    assignedWithoutProduction: number;
    assignedWithProduction: number;
}

export interface PendingActivitiesByDate {
    date: string;
    activities: number;
}

export interface SummaryActivities {
    totalActivities: number;
    assignedActivities: number;
    echometerTotalActivities: number;
    echometerAssignedActivities: number;
    leutertTotalActivities: number;
    leutertAssignedActivities: number;
    methods: string[];
    typeOfActivities: string[];
    locationWithProduction: number;
    locationWithoutProduction: number;
}

export interface InternalFilters {
    method: string[];
    typeOfActivities: string[];
    withoutProductionTaken: number;
    withProductionTaken: number;
}

export interface ActivitiesByDatesToAssigned {
    date: string;
    assignedActivitiesIds: string[];
    comment?: string;
}

const Cards = [
    {
        id: 2,
        title: "Reporte de Actividades",
        icon: "/assets/icons/report_activities.svg",
        // description: "Generar reporte de actividades asignadas",
    },
    {
        id: 1,
        title: "Asignar Actividades",
        icon: "/assets/icons/asignar_analisis.svg",
        // description: "Asignar actividades a los analistas",
    },
];

export const ActivitiesManagerModule = ({ datesToAssigned, data, open, onClose }: { datesToAssigned: any, data: Location[], open: boolean, onClose: any, }) => {

    const [loading, setloading] = useState(false)

    const [activeModule, setactiveModule] = useState(0)

    const handleClose = () => {
        onClose()
    }

    const handleClickCard = (cardId: number) => {
        setactiveModule(cardId);
    }

    return (
        <Modal
            open={open}
            onClose={!loading ? handleClose : undefined}
            sx={{ padding: "50px !important" }}
        >
            <Box className="modal_assign_module">
                {loading && (
                    <>
                        <Box className="modal_analyst_loading_background" />
                        <Box className="modal__analyst_task_loading">
                            <LinearProgress />
                            Procesando....
                        </Box>
                    </>
                )}
                <Box className="modal_header_assign">
                    <IconButton
                        aria-label="delete"
                        size="small"
                        onClick={handleClose}
                    >
                        <HighlightOffTwoToneIcon color="error" />
                    </IconButton>
                    <Box sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        // mt: 8
                    }}>
                        <Typography sx={{
                            color: "custom.blue2",
                            fontSize: "20px",
                            fontWeight: "bold"
                        }}>Gestión de Actividades</Typography>
                    </Box>
                </Box>


                {activeModule === 0 && (
                    <Grid
                        container
                        spacing={15}
                        className="cards_container_section"
                    >
                        {Cards.map((card, index) => (
                            <Paper
                                elevation={3}
                                key={index}
                                className="card_container_assign"
                                // sx={{ height: 300 }}
                                onClick={() => handleClickCard(card.id)}
                                style={{ cursor: "pointer" }}
                            >
                                <img
                                    src={card.icon}
                                    width={80}
                                    height={80}
                                    alt=""
                                />
                                <div className="card_container__title">
                                    {card.title}
                                </div>

                            </Paper>
                        ))}
                    </Grid>
                )}

                {activeModule === 1 && (
                    <AssignedModule
                        datesToAssigned={datesToAssigned}
                        data={data}
                        setloading={setloading}
                        goBack={() => setactiveModule(0)}
                    />
                )}

                {activeModule === 2 && (
                    <ReportManager
                        setloading={setloading}
                        goBack={() => setactiveModule(0)}
                    />
                )}
            </Box>
        </Modal>
    );
}